import Reveal from "./Reveal";

const FounderAccess = () => (
  <section className="px-6 pb-10 pt-20 sm:pb-14 sm:pt-28">
    <div className="mx-auto max-w-2xl rounded-3xl border border-black/10 bg-neutral-50 px-7 py-12 text-center sm:px-12 sm:py-14">
      <Reveal>
        <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          participou do escape21? já destravou a oferta fundadora da escape
          club.
        </h2>
      </Reveal>
      <Reveal delay={120}>
        <p className="mt-8 text-base leading-relaxed text-black/60 sm:text-lg">
          não precisa ter completado 100% dos 21 dias. precisa ter entrado no
          jogo.
        </p>
      </Reveal>
      <Reveal delay={220}>
        <p className="mt-6 text-base font-semibold leading-relaxed sm:text-lg">
          oferta fundadora com mais de 30% off, revelada só pra quem tá dentro
          do desafio.
        </p>
      </Reveal>
    </div>
  </section>
);

export default FounderAccess;
